// Mirrors investor-service `CryptoWalletStatus` / `TrustlineStatus` enums
// (crypto-wallet/enums/crypto.enum.ts).
export const CRYPTO_WALLET_STATUS = {
  PENDING_VALIDATION: 'pending_validation',
  ACTIVE: 'active',
  VALIDATION_FAILED: 'validation_failed',
  DEACTIVATED: 'deactivated',
} as const

export type CryptoWalletStatus = (typeof CRYPTO_WALLET_STATUS)[keyof typeof CRYPTO_WALLET_STATUS]

export const TRUSTLINE_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  FAILED: 'failed',
  REMOVED: 'removed',
} as const

export type TrustlineStatus = (typeof TRUSTLINE_STATUS)[keyof typeof TRUSTLINE_STATUS]
